<div class="thank-you-message" *ngIf="thankYouMessageVisible()" @fadeInOut>
  <p>Thanks for your feedback!</p>
  <p *ngIf="message.userFeedback">Your message: {{ message.userFeedback }}</p>
</div>

<div *ngIf="message.sender === this.type.USER" class="sender-container mt-xs">
  <div class="display-message">
    <div class="pin-container" [class.pinned]="isPinned()">
      <button
        mat-icon-button
        type="button"
        (click)="togglePin()"
        [disabled]="isPinSubmitting() || pinnedQueryService.isMutating()"
        [matTooltip]="isPinned() ? 'Unpin question' : 'Pin question'"
        matTooltipShowDelay="300"
        [attr.aria-label]="isPinned() ? 'Unpin question' : 'Pin question'">
        <mat-spinner *ngIf="isPinSubmitting()" diameter="20"></mat-spinner>
        <mat-icon
          *ngIf="!isPinSubmitting()"
          class="icon pin-icon"
          [class.pin-active]="isPinned()"
        >push_pin</mat-icon>
      </button>
    </div>
    <div class="message-sender">
      <div>
        <span class="text">{{ message.text }}</span>
      </div>
    </div>
    <div class="message-avatar">
      <mat-icon>account_circle</mat-icon>
    </div>
  </div>
</div>
<div class="reciever-container" *ngIf="message.sender === this.type.MACHINE">

  <div [ngClass]="'reciever-form-hover'">

    <div class="message-reciever">
      <div class="container-avatar">
        <img class="icon-avatar" src="../../../assets/svgs/ai-fyxt-white.svg">
      </div>
      <div [ngClass]="{'error-message': message.isError}">
        <div>
          <!-- AI reasoning: streaming "thinking" block shown ABOVE main message -->
          <fyxt-thinking-ui
            *ngIf="showReasoningLogs && message.sender === type.MACHINE && !message.isError && (message.isPending || !!message.currentThinkingStep || (message.thinkingSteps?.length || 0) > 0 || isReasoningStreaming())"
            [state]="(isReasoningStreaming() && !message.thinkingPhaseDone) ? 'thinking' : 'done'"
            [titleThinking]="'Thinking'"
            [titleDone]="message.thoughtDurationSeconds != null ? ('Thought for ' + message.thoughtDurationSeconds + 's') : 'Thought for 0s'"
            [subtitle]="message.thinkingPhaseDone ? '' : (message.currentThinkingStep || '')"
            [expanded]="!isReasoningStreaming() && reasoningExpanded()"
            [collapsible]="!isReasoningStreaming() || !!message.thinkingPhaseDone"
            [thoughts]="getThinkingThoughts(message)"
          ></fyxt-thinking-ui>

          <!-- Show message text when available (below thinking block) -->
          <span class="text" *ngIf="message.text">
            <markdown class="md-renderrer" *ngIf="!message.isError" [data]="message.text"></markdown>
          </span>
          <span *ngIf="(message.download_urls?.length || message.download_url) && !message.isError" (click)="downloadAllFiles()" class="download-link">
            Full Results
            @if(isCsvLoading()) {
              <mat-spinner diameter="20" class="ml-sxs"/>
            } @else {
              <mat-icon class="download-icon">download</mat-icon>
            }
          </span>
        </div>
        <span *ngIf="message.isError">{{ message.text }}</span>
      </div>
    </div>
    <div *ngIf="message.text && !message.isError && message.id !== 'greeting'" class="reaction-container" [ngClass]="{'reacted': !!message.reaction }">
      <div class="btn-reaction-good">
        <button mat-icon-button (click)="onThumbUp(message.id)" [disabled]="!!isFeedbackSubmitting()">
          <mat-spinner *ngIf="isFeedbackSubmitting() === reactions.good" diameter="24"></mat-spinner>
          <mat-icon
            *ngIf="!isFeedbackSubmitting()"
            [ngClass]="{'good-reaction': message.reaction === this.reactions.good}"
            class="icon"
          >thumb_up
          </mat-icon>
        </button>
        <div class="tooltip-container">
          <span class="tooltip-text">
            @if (message.reaction === this.reactions.good) {
              Remove
            } @else {
              Good
            }
            response
          </span>
        </div>
      </div>
      <div class="btn-reaction-bad">
        <button mat-icon-button (click)="onThumbDown()" [disabled]="!!isFeedbackSubmitting()">
          <mat-icon
            [ngClass]="{'bad-reaction': message.reaction === this.reactions.bad}"
            class="icon"
          >thumb_down
          </mat-icon>
        </button>
        <div class="tooltip-container">
          <span class="tooltip-text">
            @if (message.reaction === this.reactions.bad) {
              Remove
            } @else {
              Bad
            }
            response
          </span>
        </div>
      </div>
    </div>
    <!-- Feedback form for new feedback -->
    <div class="reaction-form full-width" *ngIf="showFeedbackForm()">
          <textarea
            matInput
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="3"
            cdkAutosizeMaxRows="5"
            [(ngModel)]="message.comment"
            placeholder="Tell us more"
            class="message-textarea fyxt-scroll full-width"
            [disabled]="!!isFeedbackSubmitting()"
          ></textarea>
      <div class="button-container">
        <button mat-icon-button aria-label="Send message"
          (click)="sendReaction(message.id)"
          [disabled]="!!isFeedbackSubmitting()"
          >
        <mat-icon>send</mat-icon>
        </button>
      </div>

    </div>
  </div>
</div>
